import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AudioUnlockService {
  private _unlocked = new BehaviorSubject<boolean>(false);
  unlocked$ = this._unlocked.asObservable();

  private audioCtx: AudioContext | null = null;

  async unlock() {
    try {
      // Create/resume a WebAudio context
      if (!this.audioCtx) this.audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
      if (this.audioCtx.state === 'suspended') await this.audioCtx.resume();

      // Play a 1-sample silent buffer to “unlock” audio on iOS/Safari/Chrome
      const buf = this.audioCtx.createBuffer(1, 1, this.audioCtx.sampleRate);
      const src = this.audioCtx.createBufferSource();
      src.buffer = buf;
      src.connect(this.audioCtx.destination);
      src.start(0);

      this._unlocked.next(true);
    } catch (err) {
      console.warn('Audio unlock failed:', err);
      // Keep unlocked=false; user can try again if needed
    }
  }

  get isUnlocked() {
    return this._unlocked.value;
  }
}
